import React, { useEffect, useState } from 'react'
import { Input, Modal, Radio, message } from 'antd'
import { createMyVibeProject } from '../../request'

// 校验与文案沿用个人中心 VibeCoding 空间（Profile.js 新增项目弹窗），只读复用不改 Profile。
const VIBE_PROJECT_NAME_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?$/
const VIBE_PROJECT_NAME_TIP = '项目名称只能包含小写英文、数字和短横线，不能包含空格，不能以短横线开头或结尾，最长64个字符'
const DEPLOYMENT_MODES = ['server', 'local']
const BUSINESS_SUBJECTS = ['lechun', 'superbody']

const emptyForm = () => ({
  projectName: '',
  description: '',
  deploymentMode: 'server',
  businessSubject: 'lechun'
})

/**
 * V2 总览「新建 Vibe 项目」弹窗（P4）。
 * payload 形状与个人中心 createMyVibeProject 完全一致：
 * { projectName, description, projectKind: 'application', deploymentMode, businessSubject }。
 * 只做「提交 → 请求 → 提示 → onCreated 回调」，不轮询；成功后由上层关闭弹窗并刷新项目列表。
 */
export default function MyVibeProjectCreateDialog ({ visible, onClose, onCreated }) {
  const [form, setForm] = useState(emptyForm)
  const [submitting, setSubmitting] = useState(false)

  // 每次打开都重置表单，避免上次输入残留。
  useEffect(() => {
    if (visible) {
      setForm(emptyForm())
      setSubmitting(false)
    }
  }, [visible])

  const updateField = (key, value) => setForm(prev => ({ ...prev, [key]: value }))

  const close = () => {
    if (submitting) return
    if (onClose) onClose()
  }

  const submit = () => {
    if (submitting) return
    const projectName = (form.projectName || '').trim()
    if (!projectName) {
      message.warning('请填写项目名称')
      return
    }
    if (!VIBE_PROJECT_NAME_PATTERN.test(projectName)) {
      message.warning(VIBE_PROJECT_NAME_TIP)
      return
    }
    if (DEPLOYMENT_MODES.indexOf(form.deploymentMode) < 0) {
      message.warning('请选择运行方式')
      return
    }
    if (BUSINESS_SUBJECTS.indexOf(form.businessSubject) < 0) {
      message.warning('请选择主体')
      return
    }
    setSubmitting(true)
    createMyVibeProject({
      projectName,
      description: (form.description || '').trim(),
      projectKind: 'application',
      deploymentMode: form.deploymentMode,
      businessSubject: form.businessSubject
    })
      .then(result => {
        message.success('项目已创建')
        if (onCreated) onCreated(result || null)
      })
      .catch(() => {})
      .finally(() => setSubmitting(false))
  }

  return <Modal
    className="term-my-create-modal"
    visible={visible}
    title="新建 Vibe 项目"
    width={620}
    confirmLoading={submitting}
    onCancel={close}
    onOk={submit}
    okText="创建"
    cancelText="取消"
    destroyOnClose
  >
    <div className="term-my-form">
      <div className="term-my-form-field">
        <div className="term-my-form-label">项目名称</div>
        <Input
          value={form.projectName}
          maxLength={64}
          placeholder="例如 sales-report，必须和项目文件夹名一致"
          onChange={event => updateField('projectName', event.target.value)}
        />
        <div className="term-my-form-tip">{VIBE_PROJECT_NAME_TIP}</div>
      </div>
      <div className="term-my-form-field">
        <div className="term-my-form-label">项目简介 / 备注</div>
        <Input.TextArea
          value={form.description}
          maxLength={500}
          autoSize={{ minRows: 4, maxRows: 8 }}
          placeholder="简单说明这个业务小系统的用途（最多 500 字）"
          onChange={event => updateField('description', event.target.value)}
        />
      </div>
      <div className="term-my-form-field">
        <div className="term-my-form-label">运行方式</div>
        <Radio.Group
          value={form.deploymentMode}
          buttonStyle="solid"
          onChange={event => updateField('deploymentMode', event.target.value)}
        >
          <Radio.Button value="server">服务器部署</Radio.Button>
          <Radio.Button value="local">仅本地运行</Radio.Button>
        </Radio.Group>
      </div>
      <div className="term-my-form-field">
        <div className="term-my-form-label">主体</div>
        <Radio.Group
          value={form.businessSubject}
          buttonStyle="solid"
          onChange={event => updateField('businessSubject', event.target.value)}
        >
          <Radio.Button value="lechun">乐纯</Radio.Button>
          <Radio.Button value="superbody">超体</Radio.Button>
        </Radio.Group>
      </div>
    </div>
  </Modal>
}
